import { render, staticRenderFns } from "./CobrancaBolePix.vue?vue&type=template&id=5d98a5b3&scoped=true"
import script from "./CobrancaBolePix.vue?vue&type=script&lang=ts"
export * from "./CobrancaBolePix.vue?vue&type=script&lang=ts"
import style0 from "./CobrancaBolePix.vue?vue&type=style&index=0&id=5d98a5b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d98a5b3",
  null
  
)

export default component.exports